import React from "react";
import '../../scss/components/Header.scss';
import logo from '../../img/files/logo.svg';
import { Link } from "react-router-dom";
import { NavLink } from "react-router";

const Header = () => {
    return (
        <header className="header">
            <Link to={`/`}>
                <img src={logo} className="FPSB-Logo" alt="Logo" />
            </Link>
            <nav className="main-menu">
                { process.env.REACT_APP_FPSB_PORTAL_NEWS_URL && (
                    <NavLink to={process.env.REACT_APP_FPSB_PORTAL_NEWS_URL} target="_blank">Aktuelles</NavLink>
                ) }
                { process.env.REACT_APP_FPSB_PORTAL_CONTACT_URL && (
                    <NavLink to={process.env.REACT_APP_FPSB_PORTAL_CONTACT_URL} target="_blank">Kontakt</NavLink>
                ) }
            </nav>
        </header>
    )
}

export default Header;